import {default as Inputmask} from 'inputmask';

Inputmask.extendDefaults({
	showMaskOnHover: false,
});

export default Inputmask;